export const phaseStats = {
  total: 467000,
  verified: 300400,
  pending: 120600,
  issues: 46000,
  stickersIssued: 282550,
  todayScans: 4862,
  irregularities: 214
};

export const verificationStatusData = [
  { name: 'যাচাইকৃত', value: 300400, color: '#006a4e' },
  { name: 'অপেক্ষমাণ', value: 120600, color: '#e08a00' },
  { name: 'তথ্যগত সমস্যা', value: 46000, color: '#c62828' }
];

export const stickerProgress = [
  { month: 'অক্টো', issued: 18400 },
  { month: 'নভে', issued: 52700 },
  { month: 'ডিসে', issued: 98600 },
  { month: 'জানু', issued: 156200 },
  { month: 'ফেব্রু', issued: 221900 },
  { month: 'মার্চ', issued: 282550 }
];

export const dailyVerification = [
  { day: '০৬ মার্চ', valid: 3820, invalid: 151 },
  { day: '০৭ মার্চ', valid: 4105, invalid: 178 },
  { day: '০৮ মার্চ', valid: 3460, invalid: 132 },
  { day: '০৯ মার্চ', valid: 4290, invalid: 186 },
  { day: '১০ মার্চ', valid: 4480, invalid: 197 },
  { day: '১১ মার্চ', valid: 4570, invalid: 223 },
  { day: '১২ মার্চ', valid: 4648, invalid: 214 }
];

export const divisionVerification = [
  { division: 'রমনা', scans: 652, issues: 24 },
  { division: 'লালবাগ', scans: 471, issues: 19 },
  { division: 'মতিঝিল', scans: 686, issues: 28 },
  { division: 'ওয়ারী', scans: 541, issues: 22 },
  { division: 'তেজগাঁও', scans: 611, issues: 35 },
  { division: 'মিরপুর', scans: 834, issues: 31 },
  { division: 'গুলশান', scans: 580, issues: 30 },
  { division: 'উত্তরা', scans: 487, issues: 25 }
];

export const divisionRegistered = [52400, 41800, 61200, 48600, 57300, 79500, 63100, 63100];

export interface MapPoint {
  name: string;
  lat: number;
  lng: number;
  scans: number;
  issues: number;
}

export const mapPoints: MapPoint[] = [
  { name: 'মিরপুর-১০ গোলচত্বর', lat: 23.8069, lng: 90.3687, scans: 96, issues: 2 },
  { name: 'মিরপুর-১১ বাসস্ট্যান্ড', lat: 23.8193, lng: 90.3654, scans: 54, issues: 1 },
  { name: 'ফার্মগেট মোড়', lat: 23.7576, lng: 90.3897, scans: 88, issues: 1 },
  { name: 'গুলশান-১ চত্বর', lat: 23.7806, lng: 90.4167, scans: 72, issues: 3 },
  { name: 'মহাখালী', lat: 23.7778, lng: 90.405, scans: 61, issues: 1 },
  { name: 'মতিঝিল শাপলা চত্বর', lat: 23.733, lng: 90.4172, scans: 94, issues: 2 },
  { name: 'শাহবাগ মোড়', lat: 23.7383, lng: 90.3958, scans: 77, issues: 4 },
  { name: 'তেজগাঁও সাতরাস্তা', lat: 23.7578, lng: 90.4005, scans: 58, issues: 3 },
  { name: 'লালবাগ কেল্লার মোড়', lat: 23.719, lng: 90.388, scans: 49, issues: 2 },
  { name: 'যাত্রাবাড়ী চৌরাস্তা', lat: 23.7104, lng: 90.4349, scans: 81, issues: 2 },
  { name: 'উত্তরা হাউজ বিল্ডিং', lat: 23.8759, lng: 90.3995, scans: 66, issues: 1 },
  { name: 'মোহাম্মদপুর বাসস্ট্যান্ড', lat: 23.7662, lng: 90.3589, scans: 52, issues: 1 },
  { name: 'বাড্ডা লিংক রোড', lat: 23.7808, lng: 90.4262, scans: 47, issues: 2 }
];
